import { SystemStyleObject, ThemeTypings } from "@/ui/system";
import { uiFactory } from "@/ui";
import { FunctionComponent } from "react";

export default function Icon({
  icon,
  fill,
  size,
  style
}: {
  icon: FunctionComponent;
  fill?: ThemeTypings["colors"];
  size?: string;
  style?: SystemStyleObject;
}) {
  const EnhancedIcon = uiFactory(icon);

  return (
    <EnhancedIcon
      sx={{
        path: {
          fill
        },
        w: size,
        h: size,
        minW: size,
        minH: size,
        ...style
      }}
    />
  );
}
